export const countActionsWidth = (actionsLength: number) => {
  const STARTING_WIDTH = 56
  if (actionsLength - 1 < 1) {
    return STARTING_WIDTH
  }
  return STARTING_WIDTH + (actionsLength - 1) * 40
}
